import { render, staticRenderFns } from "./newsViewSupport.vue?vue&type=template&id=5d54f89f&scoped=true&"
import script from "./newsViewSupport.vue?vue&type=script&lang=js&"
export * from "./newsViewSupport.vue?vue&type=script&lang=js&"
import style0 from "./newsViewSupport.vue?vue&type=style&index=0&id=5d54f89f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d54f89f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VBtn,VDivider,VIcon,VImg,VProgressLinear,VSheet})
